<!--
 * @Author: 孙培国
 * @Date: 2022-10-12 17:48:36
 * @LastEditors: Do not edit
 * @LastEditTime: 2023-04-11 14:56:34
 * @FilePath: \dataplaform\src\App.vue
-->
<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  created () {
    // console.warn('控制台')
  }
}
</script>

<style lang="less">
* {
  margin: 0;
  padding: 0;
}
html,
body {
  width: 100%;
  height: 100%;
}

.el-menu--popup{
  min-width: 152px !important;
}

#app {
  width: 100%;
  height: 100%;
}

.el-dropdown-menu{
  max-height: 300px;
  overflow-y: auto;
}

  .el-tooltip__popper {
    max-width: 40%;
  }
</style>
